import React from 'react';

import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";
import {observer} from "mobx-react";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {H2H} from "../h2h-widget.consts";
import {ACTION_TYPES} from "../../../core/consts";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";
import {H2hWidgetController} from "../h2h-widget.controller";
import classnames from "classnames";
import styles from '../styles/h2h-widget.module.scss';
import {SecondaryTabs} from "../../../core/components/secondary-tabs/components/secondary-tabs";

export class H2hWidgetTabsProps extends BaseProps {
  controller: H2hWidgetController;
}

export const H2hWidgetTabs = observer(({controller}: H2hWidgetTabsProps) => {
  const {state} = controller;
  const {device} = state;

  const onTabChange = (e, tab: ListItemViewModel) => {
    controller.action(H2H.ACTION_TYPES.tabChangeH2h, {
      index: tab.index,
    });
    controller.action(ACTION_TYPES.tabChange, {
      tab: tab.index === H2H.TABS_INDEXES.all ? H2H.ANALYTICS.TABS.all : H2H.ANALYTICS.TABS.homeAway,
      entityType: ANALYTICS.ENTITY_TYPES.game,
      entityId: state.gameId,
    });
  };

  const tabsProps = {
    tabs: state.tabs,
    initialIndex: state.tabsSelectedIndex,
    onChange: onTabChange
  };

  const containerProps = {
    className: classnames(styles.tabs_container, {[styles.small_view]: device.isSmallView})
  }

  return (
    <div {...containerProps}>
      <SecondaryTabs {...tabsProps}/>
    </div>
  )
});
